import './Chart.css';

import React, { useState } from 'react';

import HillChartCustom from './HillChartCustom';

const Chart = props => {
  const { snapshots, project_id, created_by, setSnapshotDict, width, height, preview, showGroups } = props;
  const [dict, setDict] = useState({});

  const handleMoved = (data) => {
    const newDict = { ...dict };
    newDict[data.id] = {
      hill_chart_x: data.x,
      scope_id: data.id,
      project_id,
      created_by,
    };
    setDict(newDict);
    if (setSnapshotDict) setSnapshotDict(newDict);
  };

  return (
    <div className="hill-chart-container">
      <HillChartCustom
        snapshots={snapshots}
        width={width}
        height={height}
        preview={preview}
        onMoved={handleMoved}
        showGroups={showGroups}
      />
    </div>
  );
};

export default Chart;
